import * as React from "react";
import debounce from "lodash/debounce";

import { Post } from "../entities";
import PostSelectBox from "./PostSelectBox";

interface Props {
  options: Post[];
  value: Post | null;
  newPostLink?: string;
  isLoading: boolean;
  locale: string;
  onComplete: (post: Post | null) => void;
  onCancel: () => void;
}

interface State {
  filteredOptions: Post[];
  tempValue: Post | null;
  searchText: string;
}

class PostSelectContainer extends React.Component<Props, State> {
  private updateFilteredOptionsDebounced: () => void;

  constructor(props: Props) {
    super(props);
    this.state = {
      filteredOptions: props.options,
      tempValue: props.value,
      searchText: "",
    };
    this.updateFilteredOptionsDebounced = debounce(this.updateFilteredOptions, 300);
  }

  public onChange = (value: Post | null) => {
    if (value === this.props.value) {
      this.props.onCancel();
    }
    this.setState({ tempValue: value }, this.onComplete);
  };

  public onComplete = () => {
    this.props.onComplete(this.state.tempValue);
  };

  public onChangeSearchText = (searchText: string) => {
    const lazy = this.props.options.length > 150; // Debounce if too many options for performance reason
    const filteredOptions = lazy ? this.state.filteredOptions : this.filterOptions(this.props.options, searchText);
    this.setState({ searchText, filteredOptions }, this.updateFilteredOptionsDebounced);
  };

  public filterOptions(options: Post[], text: string) {
    const lower = text.toLowerCase();
    const filtered = options.filter(({ title }) => {
      return title!.toLowerCase().indexOf(lower) >= 0;
    });
    return filtered;
  }

  public updateFilteredOptions = () => {
    const filteredOptions = this.filterOptions(this.props.options, this.state.searchText);
    this.setState({ filteredOptions });
  };

  public render() {
    const { newPostLink, isLoading, onCancel, locale } = this.props;
    const { tempValue, searchText, filteredOptions } = this.state;
    return (
      <PostSelectBox
        {...{ searchText, newPostLink, isLoading }}
        options={filteredOptions}
        value={tempValue}
        onChange={this.onChange}
        onChangeSearchText={this.onChangeSearchText}
        onCancel={onCancel}
        locale={locale}
      />
    );
  }
}

export default PostSelectContainer;



// WEBPACK FOOTER //
// ./frontend/src/posts/components/PostSelectContainer.tsx